import { render } from "./BomCellTag.vue?vue&type=template&id=216d27bc&scoped=true"
import script from "./BomCellTag.vue?vue&type=script&lang=js"
export * from "./BomCellTag.vue?vue&type=script&lang=js"

import "./BomCellTag.vue?vue&type=style&index=0&id=216d27bc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216d27bc"]])

export default __exports__